export default __webpack_public_path__ + "static/cross-7be91612bb715e761369d1c485df781c.svg";